/**
 * Sổ công việc nền dùng chung cho các việc âm thanh bất đồng bộ (tổng hợp
 * giọng nói ở MH-13, ghép âm thanh ở MH-12): yêu cầu bắt buộc là việc chạy nền
 * KHÔNG được chặn giao diện, người dùng phải rời màn hình được, và phải được
 * báo khi việc xong.
 *
 * Đây là một sổ Ở CẤP ỨNG DỤNG (module-level singleton), KHÔNG gắn với vòng
 * đời của một màn hình cụ thể: khi người dùng điều hướng sang màn hình khác,
 * bộ đếm thăm dò vẫn tiếp tục chạy (chỉ dừng khi tải lại toàn trang), và
 * `KhungTrang` đọc sổ này để hiện huy hiệu + danh sách ở nút "Thông báo" của
 * thanh đầu trang cho MỌI màn hình, không chỉ màn hình đã tạo ra việc đó.
 */
import { useEffect, useState } from 'react';

export type LoaiCongViecNen = 'tts' | 'ghep';
export type TrangThaiCongViecNen = 'cho' | 'dang_xu_ly' | 'thanh_cong' | 'that_bai';

export interface CongViecNen {
  id: string;
  loai: LoaiCongViecNen;
  moTa: string;
  trangThai: TrangThaiCongViecNen;
  thoiLuongGiay?: number | null;
  maLoi?: string | null;
  daXem: boolean;
}

export type TraCuuCongViecNen = (id: string) => Promise<{
  trangThai: string;
  thoiLuongGiay?: number | null;
  maLoi?: string | null;
}>;

const danhSach: CongViecNen[] = [];
const nguoiNghe = new Set<() => void>();

function bao(): void {
  nguoiNghe.forEach((f) => f());
}

export function themCongViecNen(
  job: { id: string; loai: LoaiCongViecNen; moTa: string },
  traCuu: TraCuuCongViecNen,
  chuKyMs = 3_000,
): void {
  const cv: CongViecNen = { ...job, trangThai: 'cho', daXem: false };
  danhSach.unshift(cv);
  bao();

  const h = setInterval(() => {
    void traCuu(job.id)
      .then((kq) => {
        cv.trangThai = (kq.trangThai as TrangThaiCongViecNen) ?? cv.trangThai;
        cv.thoiLuongGiay = kq.thoiLuongGiay ?? null;
        cv.maLoi = kq.maLoi ?? null;
        bao();
        if (cv.trangThai === 'thanh_cong' || cv.trangThai === 'that_bai') {
          clearInterval(h);
          if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
            try {
              new Notification(cv.moTa, {
                body: cv.trangThai === 'thanh_cong' ? 'Đã xử lý xong' : 'Xử lý thất bại',
              });
            } catch {
              /* một số môi trường kiểm thử/không phải trình duyệt không hỗ trợ Notification */
            }
          }
        }
      })
      .catch(() => clearInterval(h));
  }, chuKyMs);
}

export function danhSachCongViecNen(): CongViecNen[] {
  return danhSach;
}

export function soCongViecChuaXem(): number {
  return danhSach.filter((c) => !c.daXem).length;
}

export function danhDauDaXemCongViecNen(): void {
  danhSach.forEach((c) => (c.daXem = true));
  bao();
}

export function dungNgheCongViecNen(cb: () => void): () => void {
  nguoiNghe.add(cb);
  return () => nguoiNghe.delete(cb);
}

/** Hook React mỏng: đăng ký nghe thay đổi của sổ và buộc vẽ lại khi có. */
export function dungCongViecNen(): CongViecNen[] {
  const [, ep] = useState(0);
  useEffect(() => dungNgheCongViecNen(() => ep((n) => n + 1)), []);
  return danhSachCongViecNen();
}
